<div class="modal modal-full-screen fade show" style="display: block;">
    <div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">Edit page section</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="cancel()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                </button>
			</div>
			<div class="modal-body">

                <div class="row">
                    <div class="col-xl-4">
                        <div class="mb-3 row">
                            <label class="col-sm-2 col-form-label">Section name</label>
                            <div class="col-sm-10">
                                <input type="text" class="form-control bordered" [(ngModel)]="snippet.name" />
                                <span class="form-text m-b-none">
							Give this section a short but clear name that describes the content that will be added i.e Overview text, banner image
						</span>
                            </div>
                        </div>

                        <div class="mb-3 row">
                            <label class="col-sm-2 col-form-label">Section type</label>
                            <div class="col-sm-10">
                                <select class="form-control bordered" [(ngModel)]="snippet.type">
                                    <option *ngFor="let type of types" value="{{type.Id}}">{{type.name}}</option>
                                </select>
                                <span class="form-text m-b-none">
							What type of content is being loaded. Images, text, video or a prebuilt plugin?
						</span>
                            </div>
                        </div>


                        <div class="mb-3 row">
                            <label class="col-sm-2 col-form-label">Padding horizontal</label>
                            <div class="col-sm-10">
                                <select class="form-control bordered" [(ngModel)]="snippet.paddingH">
                                    <option *ngFor="let ph of paddingsH" value="{{ph.Id}}">{{ph.name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="mb-3 row">
                            <label class="col-sm-2 col-form-label">Padding vertical</label>
                            <div class="col-sm-10">
                                <select class="form-control bordered" [(ngModel)]="snippet.paddingV">
                                    <option *ngFor="let pv of paddingsV" value="{{pv.Id}}">{{pv.name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="mb-3 row">
                            <label class="col-sm-2 col-form-label">Background colour</label>
                            <div class="col-sm-10">
                                <select class="form-control bordered" [(ngModel)]="snippet.backgroundColour">
                                    <option *ngFor="let backgroundColour of backgroundColours" value="{{backgroundColour.Id}}">{{backgroundColour.name}}</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div class="col-xl-8">

                        <div class="m-3">
                            <editor *ngIf="snippet.type === 'wysiwyg'" [(ngModel)]="snippet.content" [apiKey]="this.env.tinymceApiKey" [init]="tinyInit"></editor>
                            <!--					<quill-editor *ngIf="snippet.type === 'wysiwyg'" [modules]="config" [(ngModel)]="snippet.contents" [style]="{'height':'150px'}"></quill-editor>-->
                        </div>

                        <div class="mb-3 row" *ngIf="snippet.type === 'plugin'">
                            <label class="col-sm-2 col-form-label">Select plugin</label>
                            <div class="col-sm-10">
                                <select class="form-control bordered" [(ngModel)]="snippet.content">
                                    <!--							<option *ngFor="let plugin of plugins" value="{{plugin.Id}}">{{plugin.name}}</option>-->
                                </select>
                            </div>
                        </div>

                        <div class="mb-3 row" *ngIf="snippet.type === 'video'">
                            <label class="col-sm-2 col-form-label">Video URL</label>
                            <div class="col-sm-10">
                                <input type="text" class="form-control bordered" [(ngModel)]="snippet.content" />
                                <span class="form-text m-b-none">
							Enter the Youtube video Id (last part of URL)
						</span>
                            </div>
                        </div>


                        <ng-container *ngIf="snippet.type === 'image'">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Does this link to an external page?</label>
                                <div class="col-sm-10">
                                    <select class="form-control bordered" [(ngModel)]="snippet.external">
                                        <option [ngValue]="1">Yes</option>
                                        <option [ngValue]="0">No</option>
                                    </select>
                                </div>
                            </div>

                            <div class="mb-3 row" *ngIf="snippet.external === 1">
                                <label class="col-sm-2 col-form-label">External Page URL</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control bordered" [(ngModel)]="snippet.externalURL" />
                                    <span class="form-text m-b-none">
							Copy and paste the link of the website page you are linking to.
						</span>
                                </div>
                            </div>

                            <div class="mb-3 row" *ngIf="snippet.external === 0">
                                <label class="col-sm-2 col-form-label">Link to a page</label>
                                <div class="col-sm-10">
                                    <select class="form-control bordered" [(ngModel)]="snippet.routeToLink">
                                        <option value="">Select page</option>
                                        <option [ngValue]="p.route" *ngFor="let p of pages">{{p.name}}</option>
                                    </select>
                                </div>
                            </div>


                        </ng-container>

                    </div>
                </div>

			</div>

			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="save()">Save</button>
			</div>
		</div>
	</div>
</div>
<div class="modal-backdrop fade show"></div>

